var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMintRedeem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9396_27118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#101233"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2002 10.8H16.8002V14.4H13.2002V16.8H16.8002V22.8H19.2002V16.8H22.8002V14.4H19.2002V10.8Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.617 8.27999C13.241 6.82707 15.5448 6 18 6C20.4552 6 22.759 6.82707 24.383 8.27999H25.7064C26.432 8.27999 27.1277 8.58912 27.6141 9.1272C28.1005 9.66527 28.3367 10.3883 28.2619 11.1099L26.6051 27.0899H29.1315C29.245 27.0883 29.3577 27.1092 29.4629 27.1515C29.5682 27.1937 29.6641 27.2565 29.7449 27.336C29.8257 27.4156 29.8899 27.5104 29.9337 27.6149C29.9774 27.7194 30 27.8316 30 27.9449C30 28.0582 29.9774 28.1704 29.9337 28.2749C29.8899 28.3795 29.8257 28.4743 29.7449 28.5538C29.6641 28.6334 29.5682 28.6961 29.4629 28.7383C29.3577 28.7806 29.245 28.8015 29.1315 28.7999H6.86847C6.755 28.8015 6.64235 28.7806 6.53705 28.7383C6.43176 28.6961 6.33592 28.6334 6.25512 28.5538C6.17431 28.4743 6.11015 28.3795 6.06635 28.2749C6.02255 28.1704 6 28.0582 6 27.9449C6 27.8316 6.02255 27.7194 6.06635 27.6149C6.11015 27.5104 6.17431 27.4156 6.25512 27.336C6.33592 27.2565 6.43176 27.1937 6.53705 27.1515C6.64235 27.1092 6.755 27.0883 6.86847 27.0899H9.3938L7.73812 11.1088C7.66391 10.3872 7.89899 9.66527 8.38478 9.1272C8.87286 8.58798 9.56801 8.27999 10.2936 8.27999H11.617ZM15.6 9.59996H20.4V13.2H24V18H20.4V24H15.6V18H12V13.2H15.6V9.59996Z",
    fill: "#CAFFCA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9396_27118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintRedeem);
export default __webpack_public_path__ + "static/media/mint_redeem.f46b12f60c3ae4e0378c752663404955.svg";
export { ForwardRef as ReactComponent };